const defaultList = [
  {
    id: "73649846",
    commodity: "apple",
    product: "Apple Sauce",
  },
  { id: "93745149", commodity: "Banana", product: "Banana Shake" },
  {
    id: "78742587",
    commodity: "Strawberry",
    product: "Strawberry Juice",
  },
  { id: "02500445", commodity: "Blue Berry", product: "Blueberry Pie" },
  {
    id: "75878742",
    commodity: "Pomogranate",
    product: "Pomogranate Juice",
  },
  { id: "02500412", commodity: "test", product: "test" },
]

export { defaultList }
